import React, { useState } from 'react';
import Chatbot from 'react-chatbot-kit';

import { createConfigWithOptions } from './config';
import MessageParser from './MessageParser';
import ActionProvider from './ActionProvider';
import 'react-chatbot-kit/build/main.css';

// Icône simple pour le bouton de chat (vous pouvez la remplacer par une image si vous voulez)
const ChatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
    <path fillRule="evenodd" d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.971v6.02c0 1.947-1.37 3.679-3.348 3.971a48.902 48.902 0 01-7.152.52c-2.43 0-4.817-.178-7.152-.52C2.87 16.541 1.5 14.81 1.5 12.859v-6.02c0-1.947 1.37-3.679 3.348-3.971zM12 18a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5A.75.75 0 0112 18zM12 6.75a.75.75 0 00-.75.75v5.25a.75.75 0 001.5 0V7.5a.75.75 0 00-.75-.75z" clipRule="evenodd" />
    <path d="M12 21.75a2.25 2.25 0 01-2.24-2.023 23.313 23.313 0 010-3.454 2.25 2.25 0 114.48 0 23.313 23.313 0 010 3.454A2.25 2.25 0 0112 21.75z" />
  </svg>
);

// ===============================================
// DANS ChatbotToggler.js, REMPLACEZ LE BOUTON ET SES ICÔNES
// ===============================================
const ChatbotToggler = ({ user }) => {
  const [showChatbot, setShowChatbot] = useState(false);

  if (!user) {
    return null;
  }
  
  const chatbotConfig = createConfigWithOptions(user.role);

// ===============================================
// DANS ChatbotToggler.js, REMPLACEZ LE 'return'
// ===============================================
return (
  <div className="fixed bottom-5 right-5 z-50">
    {/* La fenêtre de chat, affichée conditionnellement */}
    {showChatbot && (
      <div className="mb-4" style={{ width: '350px' }}>
        <Chatbot
          config={chatbotConfig}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
        />
      </div>
    )}

    {/* Le bouton flottant qui bascule l'affichage */}
    <div className="flex justify-end">
      {/* NOUVEAU : Le label textuel, qui n'est visible que si le chat est fermé */}

      <button
        onClick={() => setShowChatbot((prev) => !prev)}
        className="bg-blue-600 text-white rounded-full p-4 shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-transform duration-200 ease-in-out transform hover:scale-110"
        aria-label="Toggle chatbot"
      >
        {showChatbot ? (
          // Icône de Croix
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          // Icône d'Assistant
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
</svg>

        )}
      </button>
    </div>
  </div>
 );

};

export default ChatbotToggler;